import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import Container from "../../../../components/container/container";
import Input from "../../../../components/inputs/inputs";
import { Beat } from "../../../../plugins/spinners.plugin";
import SelectableInput from "../../../../components/inputs/SelectableInput";
import Background from "../../../../assets/images/pictures/create-store2.webp";
import LocationSearch from "../../../../components/includes/locationSearch";
// import { getAllTags } from "../../../../redux/productTags/productTagActions";
// import { getAllCategories } from "../../../../redux/productCatergory/productCategoryAction";
import { filterProductTag } from "../../../../redux/productTags/productTagActions";
import { filterProductCategory } from "../../../../redux/productCatergory/productCategoryAction";

export default function OnboardStore({
  handleChange,
  data,
  setData,
  handleSubmit,
  submitted,
  Location,
  locationId,
  locationList,
  setLocationList,
  setLocationId,
  handleRegion,
  store_phone,
  setStorePhone,
  handleBack,
  categories,
}) {
  const dispatch = useDispatch();

  const toJson = (value) => JSON.stringify(value);
  const fromJson = (value) => JSON.parse(value);
  const {
    store_name,
    store_email,
    store_address,
    store_city,
    store_state,
    store_country,
    store_description,
    store_categories,
    store_tags,
  } = data;

  useEffect(() => {
    // dispatch(getAllTags());
    // dispatch(getAllCategories());
    dispatch(filterProductTag({ type: "store" }, 1));
    dispatch(filterProductCategory({ type: "store" }, 1));

    // eslint-disable-next-line
  }, []);

  const [storeCategories, setStoreCategories] = useState([]);
  const [storeTags, setStoreTags] = useState([]);
  const [locationLoader, setLocationLoader] = useState(false);

  const { allTags } = useSelector((state) => state.productTag);
  const { allCategories } = useSelector((state) => state.productCatergory);
  const { isLoading } = useSelector((state) => state.onboard);
  const { settings } = useSelector((state) => state.application);
  const useGooglePlaces = settings?.google_places_status === "available";

  useEffect(() => {
    const storeCategories = allCategories?.data?.filter((item) => {
      return item?.type === "store";
    });
    setStoreCategories(storeCategories);
    // eslint-disable-next-line
  }, [allCategories]);

  useEffect(() => {
    const storeTags = allTags?.data?.filter((item) => {
      return item?.type === "store";
    });
    setStoreTags(storeTags);
    // eslint-disable-next-line
  }, [allTags]);

  const handleToggleTags = (value) => {
    const current = Array.isArray(data?.store_tags)
      ? [...data?.store_tags]
      : [];

    const name = typeof value === "object" ? value.name : value;
    const exists = current.includes(name);

    const updated = exists
      ? current.filter((item) => item !== name)
      : [...current, name];

    setData((prev) => ({ ...prev, store_tags: updated }));
  };

  const handleToggleCategories = (value) => {
    const current = Array.isArray(data?.store_categories)
      ? [...data?.store_categories]
      : [];

    const name = typeof value === "object" ? value.name : value;
    const exists = current.includes(name);

    const updated = exists
      ? current.filter((item) => item !== name)
      : [...current, name];

    setData((prev) => ({ ...prev, store_categories: updated }));
  };

  //This is used to set location if google places is active
  const handleSelectLocation = (place) => {
    setData((prev) => ({
      ...prev,
      store_address: place.address,
      store_city: place.city,
      store_state: place.state,
      store_country: place.country,
    }));
  };

  return (
    <div>
      <div
        className="pt-4 sm:pt-2 sm:flex items-stretch items-center py-4 max-w-7xl w-full mx-auto sm:px-6 lg:px-6"
        data-test="createStoreComponent"
      >
        <div className="dark:bg-[#121212] sm:max-w-[550px] flex-1 px-4 sm:px-10 py-10 sm:rounded-tl-[25px] sm:rounded-bl-[25px] sm:border dark:border-none">
          <div className="mb-4">
            <h3 className="text-3xl mb-3 font-semibold text-black dark:text-white">
              Set Up Your Store, Sell Fast!
            </h3>
            <p>
              Ogwugo is your dedicated business service agency, helping you
              automate daily operations and grow your customer base. Let’s bring
              your vision to life! 🚀
            </p>
          </div>
          <div className="w-full py-4">
            <form name="form" id="business-form" onSubmit={handleSubmit}>
              <div className="">
                <div
                  className={
                    "mt-4" + (submitted && store_name ? " border-red-500" : "")
                  }
                >
                  <Input.Label
                    title={"Store Name"}
                    htmlFor={"store_name"}
                    type={"text"}
                    value={store_name}
                    name={"store_name"}
                    placeholder={"Enter store name"}
                    onChange={handleChange}
                  />
                </div>

                {!useGooglePlaces && (
                  <div
                    className={
                      "mt-4" +
                      (submitted && store_address ? " border-red-500" : "")
                    }
                  >
                    <Input.Label
                      title={"Store Address *"}
                      htmlFor={"store_address"}
                      value={store_address}
                      type={"text"}
                      name={"store_address"}
                      placeholder={"Enter store Address"}
                      onChange={handleChange}
                    />
                  </div>
                )}

                {/* Phone and email */}
                <div className="grid sm:grid-cols-2 gap-4">
                  <div
                    className={
                      submitted && store_email ? " border-red-500" : ""
                    }
                  >
                    <Input.Label
                      title={"Store Email *"}
                      htmlFor={"store_email"}
                      value={store_email}
                      type={"email"}
                      name={"store_email"}
                      placeholder={"Enter store email address"}
                      onChange={handleChange}
                    />
                  </div>
                  <div
                    className={
                      submitted && store_phone ? " border-red-500" : ""
                    }
                  >
                    <Input.Phone
                      defaultCountry="NG"
                      title={"Store Phone Number"}
                      htmlFor={"store_phone"}
                      value={store_phone}
                      onChange={setStorePhone}
                    />
                  </div>
                </div>

                <div
                  className={
                    "mt-4" +
                    (submitted && store_description ? " border-red-500" : "")
                  }
                >
                  <Input.TextArea
                    title={"Store Description "}
                    htmlFor={"store_description"}
                    value={store_description}
                    type={"text"}
                    name={"store_description"}
                    placeholder={"Describe your store to us"}
                    onChange={handleChange}
                  />
                </div>

                {/* <div
                  className={
                    submitted && !store_categories ? "  border-red-500" : ""
                  }
                >
                  <label
                    htmlFor="store_categories"
                    className="block text-sm font-medium text-gray-700 dark:text-white"
                  >
                    Store Category*
                  </label>
                  <div className="mt-2 ">
                    <select
                      name="store_categories"
                      className="mt-2 block pl-3 pr-10 w-full text-base bg-[#FFFFFF] dark:bg-[#121212]  focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm rounded-sm h-[40px] px-4 py-2 mb-4 border border-gray-300"
                      onChange={handleChange}
                    >
                      <option>
                        {store_categories ?? "Select a store category"}
                      </option>
                      {categories()}
                    </select>
                    {submitted && store_categories?.length === 0 && (
                      <div className="text-primary text-xs ">
                        Store category is required
                      </div>
                    )}
                  </div>
                </div> */}

                <div className="grid sm:grid-cols-2 gap-4">
                  <div
                    className={
                      "mt-4" +
                      (submitted && store_categories ? " border-red-500" : "")
                    }
                  >
                    <label
                      htmlFor="store_categories"
                      className="text-sm font-medium text-[#151515] dark:text-white"
                    >
                      Store Categories*
                    </label>
                    <SelectableInput
                      options={storeCategories}
                      label="store_categories"
                      name={"+ Add Category"}
                      type="category"
                      selectOption={handleToggleCategories}
                    />
                  </div>

                  <div
                    className={
                      "mt-4" +
                      (submitted && store_tags ? " border-red-500" : "")
                    }
                  >
                    <label
                      htmlFor="store_tags"
                      className="text-sm font-medium text-[#151515] dark:text-white"
                    >
                      Store Tags*
                    </label>
                    <SelectableInput
                      options={storeTags}
                      label="store_tags"
                      name={"+ Add Tag"}
                      type="tag"
                      selectOption={handleToggleTags}
                    />
                  </div>
                </div>

                {/* Here, we utilize the location component to get the location data */}
                <Location
                  country_id={locationId.country_id}
                  state_id={locationId.state_id}
                  city_id={locationId.city_id}
                  loadingLocation={(value) => {
                    setLocationLoader(value);
                  }}
                  countryList={(value) => {
                    setLocationList({
                      ...locationList,
                      countryList: value,
                    });
                  }}
                  stateList={(value) => {
                    setLocationList({
                      ...locationList,
                      stateList: value,
                    });
                  }}
                  cityList={(value) => {
                    setLocationList({ ...locationList, cityList: value });
                  }}
                />

                {/* Google Places or Manual Address */}
                {useGooglePlaces && (
                  <div className="my-4">
                    <LocationSearch
                      onPlaceSelect={handleSelectLocation}
                      searchLocationTitle={"Search Store Location*"}
                    />
                  </div>
                )}
                <div className={useGooglePlaces ? "hidden" : ""}>
                  {/* country */}
                  <div className="mt-2">
                    <Input.Select
                      title={"Country*"}
                      name="country"
                      id="country"
                      className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                      htmlFor={"country"}
                      value={store_country}
                      disabled={useGooglePlaces}
                      onChange={(e) => {
                        setLocationId({
                          ...locationId,
                          country_id: fromJson(e.target.value).id,
                        });
                        handleRegion(e);
                      }}
                    >
                      <option>
                        {store_country !== ""
                          ? store_country
                          : "Select Country"}
                      </option>
                      {locationLoader ? (
                        <option>Loading...</option>
                      ) : (
                        locationList?.countryList &&
                        locationList?.countryList?.length > 0 &&
                        locationList?.countryList?.map((item, key) => {
                          return (
                            <option
                              key={key}
                              value={toJson({
                                name: item.name,
                                id: item.id,
                              })}
                              className="dark:bg-[#121212] dark:text-white"
                            >
                              {item.name}
                            </option>
                          );
                        })
                      )}
                    </Input.Select>
                    {submitted && !store_country && (
                      <div className="text-xs text-red-500">
                        Store country is required
                      </div>
                    )}
                  </div>
                  {/* State and city */}
                  <div className="grid sm:grid-cols-2 gap-4 mb-4">
                    <div className="mt-2">
                      <Input.Select
                        title={"State*"}
                        name="state"
                        id="state"
                        className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                        htmlFor={"state"}
                        value={store_state}
                        disabled={useGooglePlaces}
                        onChange={(e) => {
                          setLocationId({
                            ...locationId,
                            state_id: fromJson(e.target.value).id,
                          });
                          handleRegion(e);
                        }}
                      >
                        <option>
                          {store_state !== "" ? store_state : "Select State"}
                        </option>
                        {locationLoader ? (
                          <option>Loading...</option>
                        ) : (
                          locationList?.stateList &&
                          locationList?.stateList?.length > 0 &&
                          locationList?.stateList?.map((item, key) => {
                            return (
                              <option
                                key={key}
                                value={toJson({
                                  name: item.name,
                                  id: item.id,
                                })}
                              >
                                {item.name}
                              </option>
                            );
                          })
                        )}
                      </Input.Select>
                      {submitted && !store_state && (
                        <div className="text-xs text-red-500">
                          Store state is required.
                        </div>
                      )}
                    </div>

                    <div className="mt-2">
                      <Input.Select
                        title={"City*"}
                        name="city"
                        id="city"
                        className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                        htmlFor={"city"}
                        value={store_city}
                        disabled={useGooglePlaces}
                        onChange={(e) => {
                          setLocationId({
                            ...locationId,
                            city_id: fromJson(e.target.value).id,
                          });
                          handleRegion(e);
                        }}
                      >
                        <option>
                          {store_city !== "" ? store_city : "Select City"}
                        </option>
                        {locationLoader ? (
                          <option>Loading...</option>
                        ) : (
                          locationList?.cityList &&
                          locationList?.cityList?.length > 0 &&
                          locationList?.cityList?.map((item, key) => {
                            return (
                              <option
                                key={key}
                                value={toJson({
                                  name: item.name,
                                  id: item.id,
                                })}
                              >
                                {item.name}
                              </option>
                            );
                          })
                        )}
                      </Input.Select>
                      {submitted && !store_city && (
                        <div className="text-xs text-red-500">
                          Store city is required
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* Country, State and city end*/}
              </div>
            </form>
          </div>
          <div className="items-center flex justify-between gap-4 sm:mt-10">
            <div className="items-center flex gap-2">
              <span className="w-[10px] h-[10px] rounded-full inline-block bg-[#A39D9D] dark:bg-white"></span>
              <span className="w-[10px] h-[10px] rounded-full inline-block bg-primary"></span>
              <span className="text-sm ml-4">Phase 2 of 2</span>
            </div>

            <div className="flex gap-4">
              <button
                onClick={handleBack}
                className="rounded-md px-4 sm:mb-0 shadow-sm px-3 py-3 border border-primary text-primary text-base font-medium bg-white text-sm"
              >
                Back
              </button>

              <button
                form="business-form"
                type="submit"
                className=" rounded-md min-w-[100px] shadow-sm px-4 py-3 bg-primary text-base font-medium text-white hover:bg-red-700 text-sm"
              >
                {isLoading ? <Beat color={"#ffffff"} /> : "Submit"}
              </button>
            </div>
          </div>
        </div>
        <div
          className="hidden sm:block w-full flex-1 rounded-tr-[25px] rounded-br-[25px] bg-cover bg-center"
          style={{ backgroundImage: `url(${Background})` }}
        />{" "}
      </div>
    </div>
  );
}
